function maxError(field, length, errorText = "must be at most", type = "characters") {
  return `${errorText} ${length} ${type}`;
}

export default maxError;